import React from "react";
import styled from "styled-components";
import Button from "../../../components/Button";
import { Colors, Text } from "../../../config";

const TotalActionWrapper = ({
  amount,
  unit,
  note,
  detailNo,
  setOpenDetails,
  openDetails,
  onSelectFlight,
  isConfirmBookingPage,
}) => {
  return (
    <StyledTotalActionWrapper>
      <AmountWrapper>
        <Price>{amount}</Price>
        <HelperText>{unit}</HelperText>
      </AmountWrapper>
      <HelperText>{note}</HelperText>
      <Button
        topBottomPadding="0.5rem"
        label={openDetails === detailNo ? Text.hideDetails : Text.viewDetails}
        bgColor={Colors.lightAshOpacity10}
        fontColor={Colors.martinique}
        width="9.375rem"
        fontSize="0.75rem"
        onClick={() => setOpenDetails(detailNo)}
      />
      {!isConfirmBookingPage && (
        <Button
          topBottomPadding="0.5rem"
          label="Select Flight"
          width="150px"
          fontSize="0.75rem"
          onClick={onSelectFlight}
        />
      )}
    </StyledTotalActionWrapper>
  );
};

const StyledTotalActionWrapper = styled.div`
  background: ${Colors.ash};
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem 0;
`;
const Price = styled.div`
  font-size: 2rem;
  font-weight: 700;
`;
const HelperText = styled.div`
  font-weight: 400;
  font-size: 0.75rem;
  color: ${Colors.greyAsh};
`;
const AmountWrapper = styled.div`
  display: flex;
`;

export default TotalActionWrapper;
